// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as NetworkUtils from "../../../../../library/NetworkUtils.bs.js";
import * as SendSmsPayload from "../api-model/SendSmsPayload.bs.js";
import * as ResendSmsPayload from "../api-model/ResendSmsPayload.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as SendSmsRepoConfig from "./SendSmsRepoConfig.bs.js";
import * as CreateSmsTemplatePayload from "../api-model/CreateSmsTemplatePayload.bs.js";
import * as DeleteSmsTemplatePayload from "../api-model/DeleteSmsTemplatePayload.bs.js";

var dummySMSUser = {
			customer_partner_details: 
			[
    {
        profile: "Partner",
        name: "TestD",
        primary_mobile_number: "0000000000",
        secondary_mobile_number: null
    },
    {
        profile: "Partner",
        name: "TestD",
        primary_mobile_number: "0000000000",
        secondary_mobile_number: "0000000000"
    },
    {
        profile: "Partner",
        name: "TestD",
        primary_mobile_number: "0000000000",
        secondary_mobile_number: "0000000000"
    },
    {
        profile: "Partner",
        name: "TestD",
        primary_mobile_number: "0000000000",
        secondary_mobile_number: "0000000000"
    },
    {
        profile: "Partner",
        name: "app drv owner",
        primary_mobile_number: "0000000000",
        secondary_mobile_number: "0000000000"
    },
    {
        profile: "Partner",
        name: "testvipinsir",
        primary_mobile_number: "0000000000",
        secondary_mobile_number: "0000000000"
    },
    {
        profile: "Partner",
        name: "test",
        primary_mobile_number: "0000000000",
        secondary_mobile_number: "0000000000"
    },
    {
        profile: "Customer",
        name: "test",
        primary_mobile_number: "0000000000",
        secondary_mobile_number: null
    }
	]
		};

var dummySMSList = {
    "message_details": [
        {
            "phone_number": "0000000000",
            "message": "<#> Your Porter app verification code is 000000. Thank you. 00000000000",
            "status": "DELIVRD",
            "order_id": null,
            "created_at": "2023-05-15 17:43:30:126",
            "status_details": "delivered successfully",
            "sms_id":1
        },
        {
            "phone_number": "0000000000",
            "message": "<#> Your Porter app verification code is 000000. Thank you. 00000000000",
            "status": "DELIVRD",
            "order_id": null,
            "created_at": "2023-05-15 16:49:38:285",
            "status_details": "delivered successfully",
            "sms_id":1

        },
        {
            "phone_number": "0000000000",
            "message": "<#> Your Porter app verification code is 000000. Thank you. 00000000000",
            "status": "DELIVRD",
            "order_id": null,
            "created_at": "2023-05-15 12:18:34:233",
            "status_details": "delivered successfully",
            "sms_id":1

        },
        {
            "phone_number": "0000000000",
            "message": "Congratulations! You have just received a cashback of ₹-200.0 which you can use for your next trip. Your",
            "status": "DELIVRD",
            "order_id": null,
            "created_at": "2023-05-11 15:22:16:353",
            "status_details": "delivered successfully",
            "sms_id":1

        },
        {
            "phone_number": "0000000000",
            "message": "Congratulations! You have just received a cashback of ₹-200.0 which you can u",
            "status": "DELIVRD",
            "order_id": null,
            "created_at": "2023-05-11 15:03:17:684",
            "status_details": "delivered successfully",
            "sms_id":1

        },
        {
            "phone_number": "0000000000",
            "message": "Hi Dri To Cus Test! After a debit of ₹800.0 from your account, your final account balance is ₹-200.0",
            "status": "TEMPLATE-ID-NOT-FOUND",
            "order_id": null,
            "created_at": "2023-05-11 14:56:48:984",
            "status_details": "unknown",
            "sms_id":1

        },
        {
            "phone_number": "0000000000",
            "message": "Congratulations!",
            "status": "DELIVRD",
            "order_id": null,
            "created_at": "2023-05-11 13:31:02:609",
            "status_details": "delivered successfully",
            "sms_id":1

        },
        {
            "phone_number": "0000000000",
            "message": "<#> Your Porter app verification code is 000000. Thank you. 00000000000",
            "status": "DELIVRD",
            "order_id": null,
            "created_at": "2023-05-11 13:07:24:790",
            "status_details": "delivered successfully",
            "sms_id":1

        },
        {
            "phone_number": "0000000000",
            "message": "<#> Your Porter app verification code is 000000. Thank you. 00000000000",
            "status": "DELIVRD",
            "order_id": null,
            "created_at": "2023-05-08 14:19:18:372",
            "status_details": "delivered successfully",
            "sms_id":1

        },
        {
            "phone_number": "0000000000",
            "message": "Congratulations! You have just received a cashback of ₹-1.0 which you can use for your next trip",
            "status": "DELIVRD",
            "order_id": null,
            "created_at": "2023-05-05 12:04:29:364",
            "status_details": "delivered successfully",
            "sms_id":1

        }
    ]
};

var dummyTemplateList = {
    "templates": [
        {
        template_title: "Sample Template",
			  template_id: 1,
			  template_message: "Sample template body with long list of messages",        
        },
        {
        template_title: "Sample Template",
			  template_id: 2,
			  template_message: "Sample template body with long list of messages",        
        },
        {
        template_title: "Sample Template",
			  template_id: 3,
			  template_message: "Sample template body with long list of messages",        
        },
        {
        template_title: "Sample Template",
			  template_id: 4,
			  template_message: "Sample template body with long list of messages",        
        },
    ]
};

var dummySendSmsResponse = {
      status_code:200,
      status: "Successfull message"
    };

var dummyEditSmsTemplateResponse = {
      status_code: 200,
      status: "Successful message"
    };

function fetchSMSUser(param, country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummySMSUser
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(SendSmsRepoConfig.SMSUserResponseConverter.execute, result);
                            });
                }), "fetchSMSUser");
}

function fetchSMSList(param, country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummySMSList
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(SendSmsRepoConfig.SmsMessageResponseConverter.execute, result);
                            });
                }), "fetchSMSList");
}

function fetchSMSTemplateList(country) {
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyTemplateList
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(SendSmsRepoConfig.SMSTemplateListResponseConverter.execute, result);
                            });
                }), "fetchSMSTemplateList");
}

function sendSMSMessage(param, country) {
  JSON.stringify(SendSmsPayload.t_encode(param));
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummySendSmsResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(SendSmsRepoConfig.SmsSendMessageResponseConverter.execute, result);
                            });
                }), "sendSMSMessage");
}

function resendSMSMessage(param, country) {
  JSON.stringify(ResendSmsPayload.t_encode(param));
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummySendSmsResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(SendSmsRepoConfig.SmsSendMessageResponseConverter.execute, result);
                            });
                }), "resendSMSMessage");
}

function createSMSTemplate(param, country) {
  JSON.stringify(CreateSmsTemplatePayload.t_encode(param));
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyEditSmsTemplateResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(SendSmsRepoConfig.EditSmsTemplateResponseConverter.execute, result);
                            });
                }), "createSMSTemplate");
}

function deleteSMSTemplate(param, country) {
  JSON.stringify(DeleteSmsTemplatePayload.t_encode(param));
  return NetworkUtils.catchPromiseError(new Promise((function (resolve, param) {
                      return resolve({
                                  TAG: /* Success */0,
                                  _0: dummyEditSmsTemplateResponse
                                });
                    })).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(SendSmsRepoConfig.EditSmsTemplateResponseConverter.execute, result);
                            });
                }), "deleteSMSTemplate");
}

var SendSmsRepo = {
  fetchSMSUser: fetchSMSUser,
  fetchSMSList: fetchSMSList,
  fetchSMSTemplateList: fetchSMSTemplateList,
  sendSMSMessage: sendSMSMessage,
  resendSMSMessage: resendSMSMessage,
  createSMSTemplate: createSMSTemplate,
  deleteSMSTemplate: deleteSMSTemplate
};

export {
  SendSmsRepo ,
  
}
/* NetworkUtils Not a pure module */
